import {
  PurchaseOrder,
  PurchaseOrderLine,
} from '../../../Lib/Types/purchase-order';

export const isLineSubtotal = (line: PurchaseOrderLine) =>
  line.item_name?.includes('Subtotal');

export const isLineChargeback = (line: PurchaseOrderLine) =>
  (line.total && line.total < 0) || line.item_name?.includes('Chargeback');

export const isLineReceived = (line: PurchaseOrderLine) =>
  line.quantity_received && line.quantity_received > 0;

export const isLineFullyReceived = (line: PurchaseOrderLine) => {
  /* Subtotal and Chargeback lines are special line that are not received */
  if (isLineSubtotal(line) || isLineChargeback(line)) return true;
  return isLineReceived(line);
};

export const isPoFullyReceived = (po: PurchaseOrder) =>
  po.purchase_order_lines.every(isLineFullyReceived);
